<template>
    <div>
        <Modal id="inscricao" :open="show" :size="'modal-xl'" customSizeWid="" :FooterDefault="false" :ClassBG="true" customModalBody="" :customModalMain="'z-index:1051'">
            <template v-slot:header>
                <h6 class="modal-title">Inscrição</h6>
                <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close">
                    <i class="fas fa-times btn-close-style-v2 hover-effect"></i>
                </button>
            </template>
            <template v-slot:body>
                <div>
                    <Form ref="Form_Inscricao" @submit="submitForm">
                        <div class="row fundo-panel">
                            <div class="col-12">
                                <div class="">
                                    <label class="form-label" style="font-size: 20px">Dados Cadastrais</label>
                                </div>
                                <div class="linha-cinza" style="margin-top: -5px"></div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-6">
                                    <label for="dsEmail" class="form-label">E-mail</label>
                                    <Field name="dsEmail" label="E-mail" type="text" class="form-control shadow-v2" v-model="InscricaoCrud.instituicao.dsEmail" />
                                    <ErrorMessage name="dsEmail" class="form-error" v-show="showErrorMessage" />
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col">
                                    <label class="form-label">{{ InscricaoCrud.instituicao.tpInstituicao === 'J' ? 'CNPJ' : 'CPF' }}</label>
                                    <div class="input-group">
                                        <Field v-maska="'##.###.###/####-##'" name="nrCpfCnpj" label="nrCpfCnpj" type="text" class="form-control shadow-v2" :class="{ filled: InscricaoCrud.instituicao.nrCpfCnpj }" readonly v-model="InscricaoCrud.instituicao.nrCpfCnpj" />
                                    </div>
                                </div>
                                <div class="col">
                                    <label class="form-label">Nome</label>
                                    <Field name="nmNome" label="Nome Instituição" type="text"
                                           class="form-control shadow-v2"
                                           :class="{ filled: InscricaoCrud.instituicao.nmNome }"
                                           v-model="InscricaoCrud.instituicao.nmNome" required />
                                    <ErrorMessage name="nmNome" class="form-error" v-show="showErrorMessage" />
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col">
                                    <label class="form-label">Telefone</label>
                                    <Field name="nrTelefone" label="Telefone" type="text" class="form-control shadow-v2"
                                           :class="{ filled: InscricaoCrud.instituicao.nrTelefone }" rules="required"
                                           v-maska="'(##) ####-####'" v-model="InscricaoCrud.instituicao.nrTelefone" />
                                </div>
                                <div class="col">
                                    <label class="form-label">Celular</label>
                                    <Field name="nrCelular" label="Celular" type="text" class="form-control shadow-v2"
                                           :class="{ filled: InscricaoCrud.instituicao.nrCelular }" rules="required"
                                           v-maska="'(##) #####-####'" v-model="InscricaoCrud.instituicao.nrCelular" />
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="row">
                                    <div class="col-3">
                                        <label class="form-label">CEP</label>
                                        <Field v-maska="'#####-###'" name="dsCep" id="dsCep" label="CEP" type="text"
                                               class="form-control shadow-v2" :class="{ filled: InscricaoCrud.instituicao.dsCep }"
                                               v-model="InscricaoCrud.instituicao.dsCep"
                                               @focusout="getCEP(InscricaoCrud.instituicao.dsCep)" />
                                    </div>
                                    <div class="col-6">
                                        <label class="form-label">Logradouro</label>
                                        <Field name="dsEndereco" label="Logradouro" type="text"
                                               class="form-control shadow-v2"
                                               :class="{ filled: InscricaoCrud.instituicao.dsEndereco }"
                                               v-model="InscricaoCrud.instituicao.dsEndereco"
                                               :disabled="InscricaoCrud.instituicao.dsEndereco != ''" />
                                    </div>
                                    <div class="col-3">
                                        <label class="form-label">Numero</label>
                                        <Field  name="nrNumero" label="Numero" type="text" id="nrNumero"
                                               class="form-control shadow-v2" :class="{ filled: InscricaoCrud.instituicao.nrNumero }"
                                               v-model="InscricaoCrud.instituicao.nrNumero" ref="numeroResidenciaInput" />
                                    </div>
                                </div>
                                <div class="row mt-1">
                                    <div class="col">
                                        <label class="form-label">Complemento</label>
                                        <Field name="dsComplemento" label="Complemento" type="text"
                                               class="form-control shadow-v2"
                                               :class="{ filled: InscricaoCrud.instituicao.dsComplemento }"
                                               v-model="InscricaoCrud.instituicao.dsComplemento" />
                                    </div>
                                </div>
                                <div class="row mt-1">
                                    <div class="col">
                                        <label class="form-label">Bairro</label>
                                        <Field name="nmBairro" label="Bairro" type="text" class="form-control shadow-v2"
                                               :class="{ filled: InscricaoCrud.instituicao.nmBairro }"
                                               v-model="InscricaoCrud.instituicao.nmBairro"
                                               :disabled="InscricaoCrud.instituicao.nmBairro != ''" />
                                    </div>
                                    <div class="col">
                                        <label class="form-label">Cidade</label>
                                        <Field name="nmCidade" label="Cidade" type="text" class="form-control shadow-v2"
                                               :class="{ filled: InscricaoCrud.instituicao.nmCidade }"
                                               v-model="InscricaoCrud.instituicao.nmCidade"
                                               :disabled="InscricaoCrud.instituicao.nmCidade != ''" />
                                    </div>
                                    <div class="col">
                                        <label class="form-label">UF</label>
                                        <Field name="nmUf" label="Estado" type="text" class="form-control shadow-v2"
                                               :class="{ filled: InscricaoCrud.instituicao.nmUf }" v-model="InscricaoCrud.instituicao.nmUf"
                                               :disabled="InscricaoCrud.instituicao.nmUf != ''" />
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-12">
                                    <label class="form-label">Âmbito</label>
                                    <vue-select :options="ambitos" v-model="ambito_selected"
                                                :label-by="(a) => (a.nmAmbito)" placeholder="Digite âmbito e selecione"
                                                searchable search-placeholder="Pesquise" close-on-select clear-on-select
                                                :min="1" class="form-control shadow-v2"
                                                :class="{ filled: InscricaoCrud.idAmbito > 0 }">
                                    </vue-select>
                                </div>
                            </div>
                            <div class="col-12 mt-3" v-if="InscricaoCrud.instituicao.tpInstituicao == 'J'">
                                <div class="">
                                    <label class="form-label" style="font-size: 20px">Responsável da Inscrição</label>
                                    <div class="linha-cinza" style="margin-top: -5px"></div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <label for="nmNomeResponsavel" class="form-label">Nome</label>
                                        <Field name="nmNomeResponsavel" label="Nº Proposta" type="text" class="form-control shadow-v2"
                                               rules="required" v-model="InscricaoCrud.inscricao.nmNomeResponsavel" />
                                        <ErrorMessage name="nrProposta" class="form-error" v-show="showErrorMessage" />
                                    </div>
                                    <div class="col">
                                        <label for="dsEmailResponsavel" class="form-label">E-mail</label>
                                        <Field name="dsEmailResponsavel" label="E-mail" type="text" class="form-control shadow-v2" v-model="InscricaoCrud.inscricao.dsEmailResponsavel" />
                                        <ErrorMessage name="dsEmailResponsavel" class="form-error" v-show="showErrorMessage" />
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col">
                                        <label class="form-label">Telefone</label>
                                        <Field name="nrTelefoneResponsavel" label="nrTelefoneResponsavel" type="text" class="form-control shadow-v2"
                                               :class="{ filled: InscricaoCrud.inscricao.nrTelefoneResponsavel }" rules="required"
                                               v-maska="'(##) ####-####'" v-model="InscricaoCrud.inscricao.nrTelefoneResponsavel" />
                                    </div>
                                    <div class="col">
                                        <label class="form-label">Celular</label>
                                        <Field name="nrCelularResponsavel" label="nrCelularResponsavel" type="text" class="form-control shadow-v2"
                                               :class="{ filled: InscricaoCrud.inscricao.nrCelularResponsavel }" rules="required"
                                               v-maska="'(##) #####-####'" v-model="InscricaoCrud.inscricao.nrCelularResponsavel" />
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col">
                                        <label class="form-label">Departamento</label>
                                        <vue-select :options="departamentos" v-model="departamento_responsavel"
                                                    :label-by="(e) => (e.nmDepartamento)"
                                                    placeholder="Digite o nome do Departamento e selecione" searchable
                                                    search-placeholder="Pesquise" close-on-select clear-on-select :min="1"
                                                    class="form-control shadow-v2"
                                                    :class="{ filled: InscricaoCrud.inscricao.idDepartamentoResponsavel > 0 }">
                                        </vue-select>
                                        <Field name="idDepartamentoResponsavel" label="Departamento" type="hidden" rules="min_value:1"
                                               v-model="InscricaoCrud.inscricao.idDepartamentoResponsavel" />
                                        <ErrorMessage name="idDepartamentoResponsavel" class="form-error" v-show="showErrorMessage" />
                                    </div>
                                    <div class="col">
                                        <label class="form-label">Função</label>
                                        <vue-select :options="funcoes" v-model="funcao_responsavel"
                                                    :label-by="(e) => (e.nmFuncao)" placeholder="Digite o nome da Função e selecione"
                                                    searchable search-placeholder="Pesquise" close-on-select clear-on-select
                                                    :min="1" class="form-control shadow-v2"
                                                    :class="{ filled: InscricaoCrud.inscricao.idFuncaoResponsavel > 0 }">
                                        </vue-select>
                                        <Field name="idFuncaoResponsavel" label="Função" type="hidden" rules="min_value:1" v-model="InscricaoCrud.inscricao.idFuncaoResponsavel" />
                                        <ErrorMessage name="idFuncaoResponsavel" class="form-error" v-show="showErrorMessage" />
                                    </div>
                                </div>

                            </div>

                            <div class="col-12 mt-3" v-if="InscricaoCrud.instituicao.tpInstituicao == 'J'">
                                <div class="">
                                    <label class="form-label" style="font-size: 20px">Responsável Financeiro</label>
                                    <div class="linha-cinza" style="margin-top: -5px"></div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <label for="nmNomeFinanceiro" class="form-label">Nome</label>
                                        <Field name="nmNomeFinanceiro" label="Nº Proposta" type="text" class="form-control shadow-v2"
                                               rules="required" v-model="InscricaoCrud.inscricao.nmNomeFinanceiro" />
                                        <ErrorMessage name="nrProposta" class="form-error" v-show="showErrorMessage" />
                                    </div>
                                    <div class="col">
                                        <label for="dsEmailFinanceiro" class="form-label">E-mail</label>
                                        <Field name="dsEmailFinanceiro" label="E-mail" type="text" class="form-control shadow-v2" v-model="InscricaoCrud.inscricao.dsEmailFinanceiro" />
                                        <ErrorMessage name="dsEmailFinanceiro" class="form-error" v-show="showErrorMessage" />
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col">
                                        <label class="form-label">Telefone</label>
                                        <Field name="nrTelefoneFinanceiro" label="nrTelefoneFinanceiro" type="text" class="form-control shadow-v2"
                                               :class="{ filled: InscricaoCrud.inscricao.nrTelefoneFinanceiro }" rules="required"
                                               v-maska="'(##) ####-####'" v-model="InscricaoCrud.inscricao.nrTelefoneFinanceiro" />
                                    </div>
                                    <div class="col">
                                        <label class="form-label">Celular</label>
                                        <Field name="nrCelularFinanceiro" label="nrCelularFinanceiro" type="text" class="form-control shadow-v2"
                                               :class="{ filled: InscricaoCrud.inscricao.nrCelularFinanceiro }" rules="required"
                                               v-maska="'(##) #####-####'" v-model="InscricaoCrud.inscricao.nrCelularFinanceiro" />
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col">
                                        <label class="form-label">Departamento</label>
                                        <vue-select :options="departamentos" v-model="departamento_financeiro"
                                                    :label-by="(e) => (e.nmDepartamento)"
                                                    placeholder="Digite o nome do Departamento e selecione" searchable
                                                    search-placeholder="Pesquise" close-on-select clear-on-select :min="1"
                                                    class="form-control shadow-v2"
                                                    :class="{ filled: InscricaoCrud.inscricao.idDepartamentoFinanceiro > 0 }">
                                        </vue-select>
                                        <Field name="idDepartamentoFinanceiro" label="Departamento" type="hidden" rules="min_value:1"
                                               v-model="InscricaoCrud.inscricao.idDepartamentoFinanceiro" />
                                        <ErrorMessage name="idDepartamentoFinanceiro" class="form-error" v-show="showErrorMessage" />
                                    </div>
                                    <div class="col">
                                        <label class="form-label">Função</label>
                                        <vue-select :options="funcoes" v-model="funcao_financeiro"
                                                    :label-by="(e) => (e.nmFuncao)" placeholder="Digite o nome da Função e selecione"
                                                    searchable search-placeholder="Pesquise" close-on-select clear-on-select
                                                    :min="1" class="form-control shadow-v2"
                                                    :class="{ filled: InscricaoCrud.inscricao.idFuncaoFinanceiro > 0 }">
                                        </vue-select>
                                        <Field name="idFuncaoFinanceiro" label="Função" type="hidden" rules="min_value:1" v-model="InscricaoCrud.inscricao.idFuncaoFinanceiro" />
                                        <ErrorMessage name="idFuncaoFinanceiro" class="form-error" v-show="showErrorMessage" />
                                    </div>
                                </div>

                            </div>

                            <div class="row mt-3" style="padding-right: 0;">
                                <div class="col-6">
                                    <div class="">
                                        <label class="form-label" style="font-size: 20px">Convênio</label>
                                        <div class="linha-cinza" style="margin-top: -5px"></div>
                                        <select class="form-select" v-model="InscricaoCrud.inscricao.idConvenio">
                                            <option value="0">Selecione</option>
                                            <option value="1">Banco do Brasil</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-6" style="padding-right: 0;">
                                    <div class="">
                                        <label class="form-label" style="font-size: 20px">Salão Principal</label>
                                        <div class="linha-cinza" style="margin-top: -5px"></div>
                                    </div>
                                    <select class="form-select" v-model="InscricaoCrud.inscricao.flSalaoPrincipal">
                                        <option value="">Selecione</option>
                                        <option value="Sim">Sim</option>
                                        <option value="Não">Não</option>
                                    </select>
                                </div>
                            </div>


                            <div class="col-12 mt-2" v-if="InscricaoCrud.instituicao.tpInstituicao == 'J'">
                                <div class="d-flex justify-content-between my-2">
                                    <div class="d-flex">
                                        <label class="form-label me-2" style="font-size: 20px">Vínculo Cadastro</label>
                                        <div v-if="(InscricaoCrud.instituicao.tpInstituicao == 'F' && InscricaoCrud.instituicao.idPessoa > 0) || (InscricaoCrud.instituicao.tpInstituicao == 'J' && InscricaoCrud.instituicao.idInstituicao > 0)"  class="spinner-grow-static text-success" role="status" />
                                        <div v-else class="spinner-grow-static text-danger" role="status" />
                                    </div>
                                    <button class="btn-style-white" style="margin-right: 3px;" type="button" @click="abreModalVincular()"><i class="fas fa-user"></i> Novo</button>
                                </div>
                                <div class="linha-cinza" style="margin-top: -1px"></div>
                            </div>

                            <div class="row mt-2" v-if="InscricaoCrud.instituicao.tpInstituicao == 'J'">
                                <div class="col-12">
                                    <label class="form-label">Cadastro Vinculado</label>
                                    <select class="form-select" v-model="InscricaoCrud.instituicao.idInstituicao">
                                        <option selected value="null">Selecione</option>
                                        <option v-for="vinculo in vinculos" :key="vinculo.value" :value="vinculo.value">
                                            {{ vinculo.text }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                        </div>
                    </Form>
                </div>
            </template>

            <template v-slot:footer>
                <div class="modal-footer">
                    <button type="button" class="btn btn-close-clean-v2 mt-2" data-bs-dismiss="modal">
                        Fechar
                    </button>
                    <button type="button" class="btn btn-red-v2" @click="submitForm">
                        <i class="fas fa-save pe-2"></i>
                        Salvar
                    </button>
                </div>
            </template>

        </Modal>

        <modal-warper target="vincular_cadastro_inscricao_2" :show="isOpenModalVincularCadastro" @close="isOpenModalVincularCadastro = false">
            <VincularCadastroInstituicao :show="isOpenModalVincularCadastro" :id="'vincular_cadastro_inscricao_2'" :crud="InscricaoCrud" @fecharModal="fechou_vincular" />
        </modal-warper>

    </div>
</template>


<script>

    import Modal from "@/components/App/Modal.vue";
    import axios from "axios";
    import $ from "jquery";
    import VueNextSelect from "vue-next-select";
    import "vue-next-select/dist/index.min.css";
    import VincularCadastroInstituicao from '@/views/Gerencial/GestaoEvento/GerenciamentoInscricoes/Modais/VincularCadastro_Instituicao.vue'
    import ModalWarper from "@/components/App/ModalWarper.vue";

    export default {
        name: "Inscricao",
        components: {
            Modal,
            "vue-select": VueNextSelect, ModalWarper, VincularCadastroInstituicao
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            idEvento: {
                type: Number,
                default: 0
            },
            idInscricao: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                departamentos: [],
                funcoes: [],
                ambitos: [],

                ambito_selected: {},

                departamento_responsavel: {},
                funcao_responsavel: {},

                departamento_financeiro: {},
                funcao_financeiro: {},

                isOpenModalVincularCadastro: false,

                vinculos: [],

                InscricaoCrud: {
                    inscricao: {
                        dsEmail: '',
                        nmNomeResponsavel: '',
                        dsEmailResponsavel: '',
                        nrTelefoneResponsavel: '',
                        nrCelularResponsavel: '',
                        idDepartamentoResponsavel: '',
                        idFuncaoResponsavel: '',
                        nmNomeFinanceiro: '',
                        dsEmailFinanceiro: '',
                        nrTelefoneFinanceiro: '',
                        nrCelularFinanceiro: '',
                        idDepartamentoFinanceiro: '',
                        idFuncaoFinanceiro: '',
                        idConvenio: '',
                        flSalaoPrincipal: false
                    },
                    instituicao:
                    {
                        nmNome: '',
                        nrTelefone: '',
                        nrCelular: '',
                        dsCep: '',
                        dsEndereco: '',
                        nrNumero: '',
                        dsComplemento: '',
                        nmBairro: '',
                        nmCidade: '',
                        nmUf: '',
                        idAmbito: '',
                        nrCpfCnpj: '',
                    }
                },

            };
        },
        methods: {
            fechou_vincular() {
                this.getVinculos();
                this.isOpenModalVincularCadastro = false;
            },
            getVinculos() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_EVENTOS_API + '/Inscricao/GetDropVindulados', {
                    headers: $this.$api.getTokenEventos(),
                    params: {
                        p_idVinculo: $this.InscricaoCrud.instituicao.idInstituicao,
                        p_tpPessoa: $this.InscricaoCrud.instituicao.tpInstituicao,
                        p_nrCpfCnpj: $this.InscricaoCrud.instituicao.nrCpfCnpj,
                        p_dsEmail: $this.InscricaoCrud.instituicao.dsEmail,
                    },
                }).then(response => {
                    $this.vinculos = response.data.data.rows;
                });
            },
            submitForm() {
                let $this = this;

                if ($this.InscricaoCrud.idAmbito == null || $this.InscricaoCrud.idAmbito <= 0) {
                    $this.$toast.show('alert', 'Âmbito é obrigatorio !', true);
                    return;
                }

                $this.$refs.Form_Inscricao.validate()
                    .then(isValid => {
                        if (isValid.valid) {
                            axios.post(process.env.VUE_APP_ROOT_EVENTOS_API + '/Inscricao/Post', $this.InscricaoCrud, { headers: $this.$api.getTokenEventos() })
                                .then(function (response) {
                                    $this.$emit("fecharModal");
                                })
                                .catch(function (error) {
                                    var msg = 'Ocorreu um erro inesperado';
                                    if (error.response) {
                                        if (error.response.data.erros != '') {
                                            msg = error.response.data.errors[0];
                                        } else {
                                            msg = error.response.data.msg;
                                        }
                                    }

                                    $this.$toast.show('alert', msg, true);
                                });
                            $this.showErrorMessage = false;
                        } else {
                            throw new Error();
                        }
                    })
                    .catch(error => {
                        var msg = 'Por favor, preencha todos os campos obrigatórios.';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        $this.showErrorMessage = true;
                        $this.$toast.show('alert', msg, true);
                    });
            },
            abreModalVincular() {
                this.isOpenModalVincularCadastro = true;
            },
            GetModalInscricao() {
                let $this = this;

                axios.get(
                    process.env.VUE_APP_ROOT_EVENTOS_API + "/Inscricao/GetModalInscricao?idInscricao=" + $this.idInscricao,
                    {
                        headers: $this.$api.getTokenEventos(),
                        notLoading: false
                    }
                ).then((response) => {
                    $this.InscricaoCrud = response.data.data;

                    this.$nextTick(() => {
                        $this.ambito_selected = $this.ambitos.find((g) => {
                            return g.idAmbito == $this.InscricaoCrud.idAmbito;
                        });

                        $this.departamento_responsavel = $this.departamentos.find((g) => {
                            return g.idDepartamento == $this.InscricaoCrud.inscricao.idDepartamentoResponsavel;
                        });

                        $this.funcao_responsavel = $this.funcoes.find((g) => {
                            return g.idFuncao == $this.InscricaoCrud.inscricao.idFuncaoResponsavel;
                        });

                        $this.departamento_financeiro = $this.departamentos.find((g) => {
                            return g.idDepartamento == $this.InscricaoCrud.inscricao.idDepartamentoResponsavel;
                        });

                        $this.funcao_financeiro = $this.funcoes.find((g) => {
                            return g.idFuncao == $this.InscricaoCrud.inscricao.idFuncaoFinanceiro;
                        });

                    })

                    this.getVinculos();
                });
            },
            getDepartamento() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Departamento/Get', {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.departamentos = response.data.data.rows;
                });
            },
            getAmbito() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ambito/Get', {
                    headers: this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.ambitos = response.data.data.rows;
                });
            },
            getFuncao() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Funcao/Get', {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.funcoes = response.data.data.rows;
                });
            },

            getCEP(value) {
                let $this = this;

                axios.get('https://viacep.com.br/ws/' + value + '/json/', {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.InscricaoCrud.instituicao = {
                        ...$this.InscricaoCrud.instituicao,
                        dsCep: response.data.cep,
                        nmCidade: response.data.localidade,
                        nmUf: response.data.uf,
                        dsEndereco: response.data.logradouro,
                        nmBairro: response.data.bairro
                    };
                    $('#nrNumero').focus();
                });
            },
        },
        mounted() {
            this.getDepartamento();
            this.getAmbito();
            this.getFuncao();
        },
        watch: {
            show(n, o) {
                this.GetModalInscricao();
            },
            ambito_selected(newValue, oldValue) {
                if (newValue) {
                    this.InscricaoCrud.idAmbito = newValue.idAmbito;
                }
            },
            departamento_responsavel(newValue, oldValue) {
                if (newValue) {
                    this.InscricaoCrud.inscricao.idDepartamentoResponsavel = newValue.idDepartamento;
                }
            },
            funcao_responsavel(newValue, oldValue) {
                if (newValue) {
                    this.InscricaoCrud.inscricao.idFuncaoResponsavel = newValue.idFuncao;
                }
            },
            departamento_financeiro(newValue, oldValue) {
                if (newValue) {
                    this.InscricaoCrud.inscricao.idDepartamentoFinanceiro = newValue.idDepartamento;
                }
            },
            funcao_financeiro(newValue, oldValue) {
                if (newValue) {
                    this.InscricaoCrud.inscricao.idFuncaoFinanceiro = newValue.idFuncao;
                }
            },
        },
    };

</script>


<style scoped lang="scss">

    .spinner-grow-static {
        display: inline-block;
        width: 2rem;
        height: 2rem;
        vertical-align: text-bottom;
        background-color: currentColor;
        border-radius: 50%;
        opacity: .75;
    }

</style>